module.exports = "<p>\n  invoice-reception works!\n</p>\n"